'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';
import { useAnalytics, useTrack } from '@owlcat/app-shell';

/**
 * Identifies the current user in PostHog when the next-auth session is available.
 * Must be placed inside SessionProvider (auth-wrapped layouts) AND under the
 * shared <AnalyticsProvider> (root layout). Identity + consent gating live in the
 * shared provider; this only forwards the session user id.
 */
export function PostHogIdentify() {
  const { data: session } = useSession();
  const { identify } = useAnalytics();
  const track = useTrack();

  useEffect(() => {
    if (!session?.user?.id) return;
    identify(session.user.id, {
      email: session.user.email ?? undefined,
      name: session.user.name ?? undefined,
    });
    // Fleet analytics: one `signed_in` per browser session (login is accounts
    // SSO; inside the Telegram Mini App the session came through initData).
    try {
      const key = `ph:signed_in:${session.user.id}`;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        const miniApp = !!(window as { Telegram?: { WebApp?: { initData?: string } } }).Telegram?.WebApp?.initData;
        track('signed_in', { provider: 'sso', method: miniApp ? 'miniapp' : 'sso' });
      }
    } catch {
      /* storage blocked (private mode) — skip rather than double-count */
    }
  }, [session, identify, track]);

  return null;
}
